interface StructuredDataProps {
  canonical: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
  schemaJson?: Record<string, unknown> | Record<string, unknown>[];
}

const COLLECTION_PAGE_CANONICALS = new Set([
  "/felgen/",
  "/alufelgen/",
  "/sommerkomplettraeder/",
  "/winterkomplettraeder/",
  "/reifen/",
  "/sommerreifen/",
  "/winterreifen/",
  "/ganzjahresreifen/",
  "/offroadreifen/",
]);

const normalizeCanonicalPath = (canonical: string) => {
  const path = canonical.startsWith("http") ? new URL(canonical).pathname : canonical;
  return path.endsWith("/") ? path : `${path}/`;
};

const normalizeSchema = (schema: StructuredDataProps["schema"], canonical: string) => {
  if (!schema) return schema;

  const canonicalPath = normalizeCanonicalPath(canonical);
  if (!COLLECTION_PAGE_CANONICALS.has(canonicalPath)) return schema;

  const normalizeItem = (item: Record<string, unknown>) => ({
    ...item,
    "@type": item["@type"] === "Product" ? "CollectionPage" : item["@type"],
  });

  return Array.isArray(schema) ? schema.map(normalizeItem) : normalizeItem(schema);
};

export default function StructuredData({ canonical, schema, schemaJson }: StructuredDataProps) {
  const data = normalizeSchema(schema ?? schemaJson, canonical);
  return data ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }} /> : null;
}
